import {Button} from "react-aria-components";
import withClassName from "./withClassName";

const FilterDropdownButton = withClassName(
	Button,
	"flex cursor-pointer items-center gap-2 rounded-full border-1 border-gray-400 bg-white px-6 py-3 hover:bg-gray-100 data-[focused]:bg-gray-100"
);

export default FilterDropdownButton;
